export const JWT_TOKEN = `${process.env.REACT_APP_PREFIX}_JWT_TOKEN`
